import { IRackSection3, RACK_SECTION_TYPE3, TypePartialRackItem3 } from "@mobx/store/locations/types";
import { findIndexByXY, xyPositionRackItem } from "@utils/xyPositionRackItem";

export const checkMinerInDeletedSections3 = (
  arr: TypePartialRackItem3[],
  type: [number, number],
  currentType: [number, number]
): boolean => {
  let hasMiner = false;
  arr.forEach((item, i) => {
    if (item.pos === RACK_SECTION_TYPE3.MINER) {
      const [X, Y] = xyPositionRackItem(i, type);
      if (X > currentType[0] || Y > currentType[1]) {
        hasMiner = true;
      }
    }
  });

  return hasMiner;
};

export const compareMinersPositions3 = (
  minersPositions: IRackSection3[],
  items: IRackSection3[],
  rackType: [number, number]
): IRackSection3[] => {
  const positions = [...minersPositions];
  let compirePositions: IRackSection3[] = items.map((item) => ({
    pos: RACK_SECTION_TYPE3.EMPTY,
    x: item.x,
    y: item.y,
  }));

  while (positions.length > 0) {
    const position = positions.shift() as IRackSection3;

    const currIndex = findIndexByXY([position.x, position.y], rackType);
    compirePositions[currIndex] = position;
  }
  return compirePositions;
};
